export enum HorizontalAlignment {
  Left = 0,
  Center = 1
}
